export default class TrackingService {

    constructor() {
        //fix npe if o tracking is not available
        this.global = window.o_global
        this.global = window.o_global || {};
        if (!this.global.eventQBus) {
            this.global.eventQBus = {
                emit: () => {
                    if (window.o_global.debug.status().activated) {
                        console.log("Tracking not available.");
                    }
                }
            }
        }
    }

    sendLargeShoppromoInitialViewTrackingEvent(promoType, featureOrder, featureIndex, filledSlots, slides, featureLabels, masTrackingFeatureLabels) {
        if (slides.length === 0) {
            return
        }

        let trackingData = [this._createLargeShoppromoLabel(promoType, featureOrder, featureIndex, filledSlots, "loaded", featureLabels, masTrackingFeatureLabels)];

        [].forEach.call(slides, (slide, i) => {
            slide.setIsTracked();
            let positionInSlider = i + 1;
            let slideTrackingPayload = this._createLargeShoppromoTileLabel(promoType, positionInSlider, featureIndex, "loaded", slide.getFeatureLabels());
            trackingData.push(slideTrackingPayload);
            if (slide.hasLever()) {
                let leverLabel = this._createLeverTagLabel(slide.getLeverTrackingPayload(), slideTrackingPayload["id"], "loaded", positionInSlider);
                if (leverLabel) {
                    trackingData.push(leverLabel);
                }
            }
        });

        this.global.eventQBus.emit("tracking.bct.addFeaturesToPageImpression", trackingData);
    }

    sendSlideTrackingEvent(movementType, featureOrder, featureIndex, slide, positionInSlider, filledSlots, featureLabels, masTrackingFeatureLabels) {
        let name = "automatic";
        if (movementType === "right") {
            name = "next";
        } else if (movementType === "left") {
            name = "previous";
        }
        this._sendTrackingEvent(name, featureOrder, featureIndex, filledSlots, positionInSlider, slide, {}, "loaded", "loaded", "tracking.bct.submitAction", featureLabels, masTrackingFeatureLabels);
    }

    sendClickTrackingEvent(featureOrder, featureIndex, slide, positionInSlider, filledSlots, featureLabels, masTrackingFeatureLabels) {
        let pageCluster = window.o_util.misc.getPagecluster();
        let trackingData = {};
        trackingData["wk.promo_AttributionFeature"] = slide.getPromoType() + "_" + pageCluster;

        if (slide.getPromoType() === 'ShopPromotionLarge') {
            // manual large shoppromo
            trackingData["wk.promo_AttributionSource"] = "manual";
            trackingData["wk.promo_AttributionScore"] = "ShopPromotionLarge";
        } else {
            // assortment large shoppromo
            trackingData["wk.promo_AttributionSource"] = slide.getFeatureLabels()["dynamo_Affinity"][0];
            trackingData["wk.promo_AttributionScore"] = slide.getFeatureLabels()["dynamo_Score"][0];
        }

        this._sendTrackingEvent("click", featureOrder, featureIndex, filledSlots, positionInSlider, slide, trackingData, "clicked", "unused", "tracking.bct.submitMoveAction", featureLabels, masTrackingFeatureLabels)
        this.global.eventQBus.emit("tracking.bct.trackOnNextPageImpression", {"promo_Click": slide.getPromoType()});
    }

    sendLeverClickTrackingEvent(featureOrder, featureIndex, slide, positionInSlider, filledSlots, featureLabels, masTrackingFeatureLabels) {
        this._sendTrackingEvent("open", featureOrder, featureIndex, filledSlots, positionInSlider, slide, {}, "clicked", "clicked", "tracking.bct.submitAction", featureLabels, masTrackingFeatureLabels)
    }

    _sendTrackingEvent(name, featureOrder, featureIndex, filledSlots, positionInSlider, slide, labelTrackingData, status, leverStatus, submitAction, featureLabels, masTrackingFeatureLabels) {
        let featureTileLabel = this._createLargeShoppromoTileLabel(slide.getPromoType(), positionInSlider, featureIndex, status, slide.getFeatureLabels());
        let features = [this._createLargeShoppromoLabel(slide.getPromoType(), featureOrder, featureIndex, filledSlots, status, featureLabels, masTrackingFeatureLabels), featureTileLabel];
        if (slide.hasLever()) {
            let leverLabel = this._createLeverTagLabel(slide.getLeverTrackingPayload(), featureTileLabel["id"], leverStatus, positionInSlider);
            if (leverLabel) {
                features.push(leverLabel);
            }
        }

        let trackingData = {
            name: name,
            features: features
        }

        this.global.eventQBus.emit(submitAction, labelTrackingData, trackingData);
    }

    _createLargeShoppromoLabel(promoType, featureOrder, featureIndex, filledSlots, status, labels, masTrackingFeatureLabels) {
        const mergedLabels = {
            ...labels,
            ...masTrackingFeatureLabels
        }
        return {
            id: this._getIdPrefixForPromoType(promoType) + featureIndex,
            name: promoType,
            position: featureOrder,
            status: status,
            labels: mergedLabels
        }
    }

    _createLargeShoppromoTileLabel(promoType, positionInSlider, featureIndex, status, labels) {
        const idPrefix = this._getIdPrefixForPromoType(promoType);
        return {
            id: idPrefix + featureIndex + "_tile" + positionInSlider,
            parentId: idPrefix + featureIndex,
            name: promoType + "-Tile",
            position: positionInSlider,
            status: status,
            labels: labels
        }
    }

    _getIdPrefixForPromoType(promoType) {
        if (promoType === "ShopPromotionLarge") {
            // manual large shoppromo
            return "ft3_splm"
        } else {
            // assortment large shoppromo
            return "ft3_spla"
        }
    }

    _createLeverTagLabel(trackingPayload, parentId, status, position) {
        if (!trackingPayload) {
            return null;
        }
        trackingPayload["id"] = parentId + "_b"
        trackingPayload["parentId"] = parentId;
        trackingPayload["status"] = status;
        trackingPayload["position"] = position;
        return trackingPayload;
    }

}
